import React, { useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';
import { useLocation } from 'react-router-dom';

const Layout = ({ children }) => {
  const { pathname } = useLocation();

  // Scroll to top + move focus to main on route change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
    const main = document.getElementById('main-content');
    if (main) {
      main.setAttribute('tabindex', '-1');
      main.focus({ preventScroll: true });
    }
  }, [pathname]);

  // Reveal-on-scroll observer (re-init on route change)
  useEffect(() => {
    const elements = document.querySelectorAll('.reveal');
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    elements.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-cream">
      <a href="#main-content" className="skip-link">
        דלג לתוכן הראשי
      </a>
      <Header />
      <main id="main-content" className="flex-1 outline-none" role="main">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
